<template lang="">
<div class="" style="height:100%">
    <div class="handleBox flex flex-jc-sb flex-ai-c">
        <el-page-header @back="goBack" content="推文" style="color:#95A1B9">
        </el-page-header>
        <div class="">
            <el-button type="primary" size="small" @click="onSubmit" style="width:120px;margin:0 20px 0 auto;display:inherit;" v-if="show==false">提交</el-button>
        </div>
    </div>
    <div class="commonMain">
        <el-form ref="formAuth" :rules="formRules" :model="formData" label-width="93px" label-position="right" size="small" class="alertForm alertForm2">
            <el-form-item label="推文标题" prop="title">
                <el-input v-model="formData.title" autocomplete="off" :disabled="show"></el-input>
            </el-form-item>
            <el-form-item label="基础浏览数" prop="view_base">
                <el-input v-model.number="formData.view_base" autocomplete="off" :disabled="show"></el-input>
            </el-form-item>
            <el-form-item label="基础点赞数" prop="zan_base">
                <el-input v-model.number="formData.zan_base" autocomplete="off" :disabled="show"></el-input>
            </el-form-item>
            <el-form-item label="推文主图" prop="main_pic" style="width:100%;">
                <div class="photoBox">
                    <div class="photo flex flex-wrap">
                        <div class="" v-if="formData.main_pic">
                            <el-image :src="getImgUrl(formData.main_pic)" fit="cover" :preview-src-list="[domain + '/' + formData.main_pic]"></el-image>
                            <i class="el-icon-error" @click="deleteMain_pic(index)" v-if="show==false"></i>
                        </div>
                        <label v-if="formData.main_pic==''">
                            <i class="el-icon-plus"></i>
                            <input type="file" class="uploadMainPic" :value="filevalue" style="display:none" @change="upload('uploadMainPic')" />
                        </label>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label=" 详细内容" style="width:100%;margin-right: 1%;" prop="content">
                <editorBar :editorMain="formData.content" @change="editorChange" :mayEdit="show"></editorBar>
            </el-form-item>

        </el-form>

        <!-- 图片放大查看 -->
        <el-dialog title="图片查看" :visible.sync="dialogVisible" :modal-append-to-body="false">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import editorBar from '@/components/editorBar';
export default {
    components: {
        editorBar, //富文本编辑器
    },
    data() {
        return {
            filevalue: '',
            formData: {
                main_pic: '',
                content: ''
            },
            dialogVisible: false,
            dialogImageUrl: '',
            zt: {},
            formRules: {
                title: [{
                    required: true,
                    message: '请输入推文标题',
                    trigger: 'blur'
                }],
                main_pic: [{
                    required: true,
                    message: '请上传推文主图',
                    trigger: 'blur'
                }],
                content: [{
                    required: true,
                    message: '请输入详情',
                    trigger: 'blur'
                }],
            },
            taginputValue: '', //tag新建时 input的值
            main_pic: [{
                required: true,
                message: '请上传推文主图',
                trigger: 'blur'
            }],
            content: [{
                required: true,
                message: '请输入详情',
                trigger: 'blur'
            }],
            show:false,
        }
    },
    mounted() {

        if (this.$route.query.row) { //赋值
            this.formData = JSON.parse(this.$route.query.row);
        }

        if(this.$route.query.show){ //查看 不可编辑
            this.show=true;
        }
    },
    methods: {
        /**
         * 接收富文本子组件输入值
         */
        editorChange: function(value) {
            this.formData.content = value;
        },
        goBack() {
            this.$router.go(-1)
        },
        // 查看图片
        showImg: function(url) {
            this.dialogImageUrl = this.domain + '/' + url;
            this.dialogVisible = true;
        },
        // 图片转换
        getImgUrl(item) {
            var url = this.domain + '/' + item;
            return url;
        },
        // 附件和图片上传获取接口返回的路径
        upload(uploadelement) {
            var loads = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                customClass: 'myLoading',
            });

            var formData = new FormData();
            formData.append('pic', document.querySelector('.' + uploadelement).files[0]);
            axios.post(this.domain + '/admin/article/upPic', formData).then(re => {
                loads.close();
                if (re.data.code == '0000') {
                    this.filevalue = "";
                    this.formData.main_pic=re.data.data.data;
                } else {
                    this.$message.error(re.data.msg);
                }
                this.$refs.formAuth.validateField('main_pic');
            }).catch(function() { // 请求失败处理
                loads.close();
            });
        },
        // 删除主图
        deleteMain_pic() {
            this.formData.main_pic = '';
            this.$refs.formAuth.validateField('main_pic');
        },
        onSubmit() {
            this.$refs['formAuth'].validate((valid) => {
                // console.log(valid);
                if (valid) {
                    var url2 = '/admin/article/save';
                    this.http.post(url2, this.formData).then(() => {
                        this.formData = {
                            main_pic: '',
                            content: ''
                        };
                        this.$message({
                            message: '提交成功!',
                            type: 'success'
                        });
                    });
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="css">
.w-e-menu{
    z-index: 1900 !important;
}
.w-e-text-container{
    z-index: 1009 !important;
    min-height: 260px !important;/*!important是重点，因为原div是行内样式设置的高度300px*/
}
.el-page-header__content {
    color: #95A1B9
}

.el-tag {
    margin-right: 10px;
    margin-bottom: 3px;
}

.button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    /* margin-left: 10px; */
    /* vertical-align: bottom; */
}
</style>
